
import * as React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { useTheme , Text} from '../_primatives';

interface ListHeaderProps {
    title: string;
    isMediumScreenOrLarger: boolean;
    borderWidth?: number;
    style?: ViewStyle;
    children?: React.ReactNode;
}

const ListHeader = (props: ListHeaderProps) => {
    const theme = useTheme();
    const MAIN_COLOR: string = theme['color-primary-default'];
    return (
        <View style={[{ marginVertical: 20, marginBottom: 30, paddingHorizontal: props.isMediumScreenOrLarger ? 0 : 23 }, props.style]}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap' }}>
                <View>
                    <Text category='h1'>{props.title}</Text>
                    <View style={{ width: (props.borderWidth || props.borderWidth === 0) ? props.borderWidth : 90, backgroundColor: MAIN_COLOR, height: 4 }}></View>
                </View>
                {props.children}
            </View>
        </View>
    );
};

export default ListHeader;

const styles = StyleSheet.create({
    container: {}
});
